export default __webpack_public_path__ + "images/GB.27b6cba.png";